import gql from 'graphql-tag';

export const CREATE_CUSTOM_DEEP_LINK_MUTATION_BULK = gql`
    mutation CreateCustomDeepLinkBulk($data: [AffiliateDeepLinkCreateInput!]!) {
        createAdditionalDeeplinks(data: $data)
    }
`;
